import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, apiErr } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";
import api from "@/lib/api";

export default function StaffAccept() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/staff/invite/${token}`).then((r) => setInvite(r.data)).catch((e) => setErr(apiErr(e))).finally(() => setLoading(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/staff/accept", { token, password });
      setUser(data); toast.success("Account created!"); navigate("/staff");
    } catch (e2) { setErr(apiErr(e2)); setSaving(false); }
  };

  return (
    <AuthShell title="Accept your invitation" sub="Set up your Masaya staff account.">
      {loading && <p className="text-[#635B52]">Checking your invitation…</p>}
      {!loading && !invite && <p className="text-red-600" data-testid="accept-error">{err || "This invitation is invalid or has expired."}</p>}
      {!loading && invite && (
        <form onSubmit={submit} className="space-y-4" data-testid="staff-accept-form">
          <p className="text-sm text-[#635B52]">Welcome, <strong>{invite.name}</strong> ({invite.email}). Choose a password.</p>
          <div><label className="text-sm font-medium text-[#2C2621]">Create password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="accept-password" /></div>
          {err && <p className="text-sm text-red-600" data-testid="accept-inline-error">{err}</p>}
          <button type="submit" disabled={saving} className={btnCls} data-testid="accept-submit">{saving ? "Creating…" : "Create my account"}</button>
        </form>
      )}
    </AuthShell>
  );
}
